import {LoginPage} from "./page/LoginPage"
import './sass/styles.sass';
import ReactComponent from "./app/ReactComponent";
import {BrowserRouter, Navigate, redirect, Route, Routes} from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import {HeaderHOC} from './layout/Header'
import {Footer} from "./layout/Footer";
import {DashboardPage} from "./page/DashboardPage";
import {ReservationPage} from "./page/ReservationPage";
import {RewardsPage} from "./page/RewardsPage";
import {HealthPage} from "./page/HealthPage";
import {ProfilePage} from "./page/ProfilePage";
import {ReservationConfirm} from "./page/ReservationConfirm";
import {LostPasswordPage} from "./page/LostPasswordPage";
import {RegistrationPage} from "./page/RegistrationPage";
import {ReservationOverviewPage} from './page/ReservationOverviewPage';
import {RewardsHistoryPage} from "./page/RewardsHistoryPage";
import PointsHistoryPage from "./page/PointsHistoryPage"
import {QuestionnairePage} from "./page/QuestionnairePage"
import {NotificationsPage} from "./page/NotificationsPage"
import {getQueryParameter, pushLoginEvent, pushAuthDataLayer} from './helpers/global'
import {ProfileUpdatePageHOC} from './page/ProfileUpdatePage'
import {CompensationsOverviewPage} from './page/CompensationsOverviewPage'
import {ProfileUpdateOtherPage} from './page/ProfileUpdateOtherPage'
import {GOOGLE_CLIENT_ID} from './services/google'
import {GoogleAuthService} from './services/GoogleAuthService'

export default class Root extends ReactComponent {
  state = {
    isMobileApp: false
  }

  constructor(props) {
    super(props)

    this.state = {
      is_authorized: false,
      customer_id: null,
      is_test_user: null,
      loading: true,
      overlayVisibility: true
    }

  }

  async componentDidMount() {
    void this.updateState({
      isMobileApp: (getQueryParameter("isHideMenu") || "").toLowerCase() === "true"
    })

    this.$app.checkAndExtendCareCloudToken()

    try {
      let response = await this.$app.$auth()

      this.setState(prevState => ({
        ...response,
        loading: false
      }))

      pushAuthDataLayer(response)

      setTimeout(() => {
        void this.updateState({overlayVisibility: false})
      }, 500)

    } catch (error) {
      console.log(error)

      await this.updateState({loading: false})
    }

    sessionStorage.removeItem('googleUser')

  }

  get $auth() {
    return {
      is_authorized: this.state.is_authorized,

      getCustomerID: () => {

        return this.state.customer_id

      },

      authenticate: async (data) => {

        try {

          const res = await this.$api({
            action: "login",
            method: "POST",
            data: data
          })

          if (res.hasOwnProperty('was_successfull') && res.was_successfull === false) {

            this.handleError(res)

            return false

          }

          // TODO: IMPORTANT, response is null add something
          const touchRes = await this.resolveLogin(res)

          await GoogleAuthService.linkGoogleAccount()

          pushLoginEvent(touchRes.customer_id)

          return true

        } catch (e) {

          this.handleError(e)

          return false

        }
      },

      authenticateTestUser: () => {

        this.$api({
          action: "login-test-user",
        }).then((res) => this.resolveLogin(res))

      },

      logout: () => {

        this.$app.deleteCareCloudToken()

        this.$api({action: "logout"}).then(res => {
          if (res && res.hasOwnProperty('was_successfull') === true) {
            void this.resolveLogin()
            redirect('/')
          }
        })

      },

      resolveLogin: async (res) => await this.resolveLogin(res)
    }
  }

  async authUser(data) {
    await this.$api({
      action: "login",
      method: "POST",
      data: data
    }).then(async (res) => {
      //if (res.was_successfull !== true) {
        //this.inputPassword.current.value = ""
        //this.inputEmail.current.focus()
      //}
      // TODO: IMPORTANT, response is null add something
      await this.resolveLogin(res)


    }).catch(e => {
      console.log(e)
    })

  }

  authTestUser() {
    this.$api({
      action: "login-test-user",
    }).then((res) => this.resolveLogin(res))
  }

  async resolveLogin(response = null) {
    const res = await this.$api({
      action: "touch"
    })

    this.$app.STORE = res
    this.setState(prevState => ({...res}))

    if(res.hasOwnProperty("token") && res.token !== null && res.token !== "" && res.token !== undefined)
      this.$app.saveCareCloudToken(res.token)

    pushAuthDataLayer(res)

    return res

  }

  render() {
    return (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrowserRouter>
          <div className={`App ${this.state.dev === true ? "dev_mode" : ""} ${this.state.isMobileApp ? "is-mobile-app" : ""}`}>
            <HeaderHOC $auth={this.$auth}/>

            {this.state.overlayVisibility && (
              <div className={`loading-overlay-layer ${this.state.loading || 'fade-out'}`}>

              </div>
              )}

            {!this.state.loading && (
              <>
                {!this.state.is_authorized ? (
                  <Routes>
                    <Route path="/" element={<LoginPage  $auth={this.$auth}/>}></Route>
                    <Route path="/lost-password" element={<LostPasswordPage/>}></Route>
                    <Route path="/registration" element={<RegistrationPage $auth={this.$auth}/>}></Route>
                    <Route path="*" element={<Navigate to="/" replace />}></Route>
                  </Routes>

                ) : (

                  <Routes>
                    <Route path="/" element={<DashboardPage auth={this.state.auth}/>}></Route>
                    <Route path="/reservation" element={<ReservationPage $auth={this.$auth}/>} ></Route>
                    <Route path="/reservation-confirm" element={<ReservationConfirm/>}></Route>
                    <Route path="/rewards" element={<RewardsPage/>}></Route>
                    <Route path="/rewards-history" element={<RewardsHistoryPage/>}></Route>
                    <Route path="/points-history" element={<PointsHistoryPage/>}></Route>
                    <Route path="/notifications" element={<NotificationsPage/>}></Route>
                    <Route path="/health" element={<HealthPage/>}></Route>
                    <Route path="/profile" element={<ProfilePage/>}></Route>
                    <Route path="/profile-update" element={<ProfileUpdatePageHOC/>}></Route>
                    <Route path="/profile-update-other" element={<ProfileUpdateOtherPage/>}></Route>
                    <Route path="/compensations-history" element={<CompensationsOverviewPage/>}></Route>
                    <Route path="/reservations" element={<ReservationOverviewPage/>}></Route>
                    <Route path="/survey" element={<QuestionnairePage type="registration" />}></Route>
                    <Route path="/survey-registration" element={<QuestionnairePage type="registration" />}></Route>
                    <Route path="/survey-pruvodka" element={<QuestionnairePage type="guide" />}></Route>
                    <Route path="/survey-prvodarce" element={<QuestionnairePage type="prvodarce" />}></Route>
                    <Route path="/survey-obnoveni-kvalifikace" element={<QuestionnairePage type="obnoveni_kvalifikace" />}></Route>
                    <Route path="/survey-annual" element={<QuestionnairePage type="annual" />}></Route>
                  </Routes>

                )}
                <Footer/>
              </>)}
          </div>
        </BrowserRouter>
      </GoogleOAuthProvider>
    )
  }
}